import "../../styles/sidePanel.css"
import { dateFormat, mapProjectScanToVulnsFixed } from "../../classes/utils"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGreaterThan } from '@fortawesome/free-solid-svg-icons'
import ScansTable from "./ScansTable"
import SelectedScanTable from "./SelectedScanTable"
export default function SidePanel({project, projectScans, projectUUID, selectedScan, setSelectedScan}) {
    let mappedSelectedScan
    if(selectedScan) mappedSelectedScan = mapProjectScanToVulnsFixed(project.remediations, selectedScan)
    return (
        <div className="side-panel bg-gray-100 rounded-md shadow-md h-fit w-full">
            <div className="p-2 flex items-center h-16">
                { selectedScan ? <div className="flex items-center p-2">
                    <h1 className="mr-2 text-start text-md w-fit whitespace-nowrap md:text-lg text-slate-500 cursor-pointer hover:text-slate-600" onClick={(e) => setSelectedScan("")}>Project scans</h1>
                    <FontAwesomeIcon className="mr-2 text-slate-500" icon={faGreaterThan} />
                    <h1 className="text-lg font-bold text-black truncate whitespace-break-spaces">Scan - {dateFormat(selectedScan.timestamp)}</h1>
                </div>: <h1 className="p-2 font-bold text-start text-md md:text-lg mr-2 text-text-black">Project scans</h1>}
            </div>
            { selectedScan ? <SelectedScanTable mappedSelectedScan={mappedSelectedScan}/>
            : <ScansTable projectScans={projectScans} setSelectedScan={setSelectedScan} projectUUID={projectUUID}/>
            }
        </div>
    )
}